import { legacyToBookingsSettings } from '../businessInfo/legacyToSettingsBusinessInfo';
import { legacyToSettingsFeatures } from '../activeFeature/legacyToSettingsFeatures';
import { BusinessPropertyName, getBusinessInfo, getCustomProperties, isPropertyEnabled } from '../businessInfo/businessInfo';
export const legacyToSettingsResponse = legacy => {
  const info = getBusinessInfo(legacy);
  const isMultiServiceAppointmentsEnabled = isPropertyEnabled(legacy, BusinessPropertyName.MULTI_SERVICES_APPOINTMENTS);
  const isCartEnabled = isPropertyEnabled(legacy, BusinessPropertyName.IS_CART_ENABLED);
  const customProperties = getCustomProperties(legacy);
  const bookingsSettings = {
    siteProperties: legacyToBookingsSettings(legacy).siteProperties,
    displayTimeZone: legacyToBookingsSettings(legacy).displayTimeZone,
    features: legacyToSettingsFeatures(legacy.activeFeatures),
    extendedFields: {
      customProperties: [...((customProperties == null ? void 0 : customProperties.map(prop => ({
        namespaces: {
          [prop.propertyName ?? '']: prop.value ?? ''
        }
      }))) ?? []), {
        namespaces: {
          ...(info != null && info.businessType ? {
            ['business type']: [info == null ? void 0 : info.businessType]
          } : {}),
          ...(info != null && info.premiumInfo ? {
            ['premium info']: [info == null ? void 0 : info.premiumInfo]
          } : {})
        }
      }]
    },
    cartCheckout: {
      enabled: isCartEnabled
    },
    multiServiceAppointments: {
      enabled: isMultiServiceAppointmentsEnabled
    }
  };
  return {
    bookingsSettings
  };
};
//# sourceMappingURL=legacyToSettingsResponse.js.map